import styled, { breakpoints } from '../../../../styles/theme';
import { TopNavbarStyled } from '../../TopNavbarStyled';
import { rem } from 'polished';

export const TopNavbarStyledOV = styled(TopNavbarStyled)`
    background: ${(p) => p.theme.colors.grey8};
    border-bottom: none;

    .topnavbar-grid {
        padding: 0;
        width: 100vw;
        @media (min-width: ${breakpoints.xs}px) {
            width: 100%;
            padding: 0 10px;
        }
    }

    .content {
        display: flex;
        justify-content: center;
        position: relative;

        &-title {
            text-transform: uppercase;
            font-size: ${(p) => p.theme.fontSizes.textMedium};
            line-height: ${rem('28px')};
            font-family: ${(p) => p.theme.fonts.fontBase};
            font-weight: ${(p) => p.theme.fontWeights.textMedium};
            color: ${(p) => p.theme.colors.black};

            @media (min-width: ${breakpoints.xs}px) {
                font-size: ${rem('21px')};
                line-height: ${rem('23px')};
            }
        }

        &-step {
            font-weight: 700;
        }
    }

    .topnavbar-returnlink {
        cursor: pointer;
        color: ${(p) => p.theme.colors.black};
        font-weight: ${(p) => p.theme.fontWeights.textMedium};
        font-family: ${(p) => p.theme.fonts.fontSecondary};
        text-transform: uppercase;
        font-size: ${(p) => p.theme.fontSizes.textBase};
        border: none;
        display: flex;
        align-items: baseline;
        min-width: ${rem('80px')};
        padding: 0.6rem 1rem;

        &__text {
            display: none;

            @media (min-width: ${breakpoints.xs}px) {
                display: inline-block;
                font-family: ${(p) => p.theme.fonts.fontBase};
            }
        }

        &:hover,
        &:focus-visible {
            @media (max-width: ${breakpoints.xs}px) {
                background: none;

                .icon-wrapper {
                    svg {
                        path {
                            stroke: ${(p) => p.theme.colors.grey5};
                        }
                    }
                }
            }
        }

        .icon-wrapper {
            width: ${rem('13px')};

            @media (min-width: ${breakpoints.xs}px) {
                width: ${rem('13px')};
                margin-right: ${rem('4px')};
            }
        }

        svg {
            height: ${rem('36px')};
            width: ${rem('30px')};

            @media (min-width: ${breakpoints.xs}px) {
                height: ${rem('6px')};
                width: ${rem('13px')};
                margin: 0 0 ${rem('2px')} 0;
                path {
                    stroke: ${(p) => p.theme.colors.grey5};
                }
            }
        }
    }

    .save-button {
        border-color: ${(p) => p.theme.colors.primary};
        color: ${(p) => p.theme.colors.primary};
        font-family: ${(p) => p.theme.fonts.fontBase};
        font-size: ${rem('14px')};
        padding-right: ${rem('34px')};
        padding-left: ${rem('34px')};
    }

    .Select {
        &__control {
            border: none;
        }

        &__indicators {
            padding: 4px;

            @media (min-width: ${breakpoints.sm}px) {
                padding: 5px;
            }

            @media (min-width: ${breakpoints.md}px) {
                padding: 8px;
            }
        }
    }
`;
